import Vue from "vue";
import axios from "axios";
import {inject, provide, reactive, toRefs, computed} from "@vue/composition-api";
import {syncItemChanges} from "../../plugins/formatting";

export const state = reactive({
    current_project: null,
    project_status: {
        active: 1,
        cancelled: 2,
        archived: 4
    },
    projectsFetched: false,
    list: []
});

export const actions = {
    // This is a special case for HR factory
    // we removed the option to rename projects,
    // however they should still have "events" as the name
    // not ideal, but don't know if there is a better way
    isEventTypeCompany(companyId) {
        return companyId === 15934
    },
    fetchProjects(params) {
        return new Promise((resolve, reject) => {
            axios
                .get("projects", {params: params})
                .then(resp => {
                    resolve(resp.data)
                })
                .catch(ex => {
                    reject(ex)
                });
        });
    },
    setProjectsFetched(isFetched, listOfProjects = null) {
        state.projectsFetched = isFetched
        if (listOfProjects !== null) state.list = listOfProjects
    },
    fetchProject(project_id, for_edit = false, load_default_client_contact = false) {
        return new Promise((resolve, reject) => {
            if (state.current_project != null && state.current_project.id === project_id && !for_edit) {
                resolve();
                return;
            }
            let params = {}
            if (for_edit) params.for_edit = 1;
            if (load_default_client_contact) params.load_default_client_contact = 1;
            axios
                .get("projects/{0}".format(project_id), {params})
                .then(resp => {
                    state.current_project = resp.data;
                    if (for_edit)
                        resolve(resp.data);
                    else
                        resolve();
                })
                .catch(ex => reject(ex));
        });
    },
    saveProject(data) {
        return new Promise((resolve, reject) => {
            axios
                .post("projects", data)
                .then(resp => {
                    if (state.current_project != null && state.current_project.id === resp.data.id)
                        syncItemChanges(state.current_project, resp.data);
                    resolve(resp.data);
                })
                .catch(ex => reject(ex));
        });
    },
    deleteProject(project_id) {
        return new Promise((resolve, reject) => {
            axios
                .delete("projects/{0}".format(project_id))
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    projectAction(project_id, action) {
        return new Promise((resolve, reject) => {
            axios
                .post("projects/{0}/{1}/".format(project_id, action))
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    fetchWorkflowChildren(account_id, workflow_id) {
        return new Promise((resolve, reject) => {
            let params = {
                account_id: account_id,
                type: "project",
                workflow_id,
                sortBy: "name",
                itemsPerPage: 200,
                page: 1
            };
            axios
                .get("projects", {params: params})
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    clearCache() {
        state.current_project = null;
    },
    updateCache(changes) {
        if (state.current_project != null && state.current_project.id === changes.id)
            syncItemChanges(state.current_project, changes);
    },
    fetchProjectHistory(project_id) {
        return new Promise((resolve, reject) => {
            axios
                .get("projects/{0}/history".format(project_id))
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    }
};

export const getters = {
    projectsList: computed(() => state.list),
    projectsFetched: computed(() => state.projectsFetched),
    projectStatuses: state.project_status
}

export const key = Symbol("ProjectModule");

export const provideProject = () => {
    provide(key, {
        ...toRefs(state),
        ...toRefs(getters),
        ...actions
    });
};

export default () => inject(key);
